import { FunctionComponent } from 'react';

import styles from './Error404.module.scss';

export const Error404: FunctionComponent = () => {
  return (
    <div className={'page ' + styles.page}>
      <div className={styles.message}>
        <div className={styles.main}>404 Not found.</div>
      </div>
    </div>
  );
};
